import { TicketListItemModel } from "@jugl-web/rest-api/tickets/models/TicketListItem";
import { TableCell } from "@jugl-web/ui-kit";
import { useFormattedDate } from "@jugl-web/utils/hooks/useFormattedDate";
import { FC, useMemo } from "react";

interface CreatedAtCellContentProps {
  ticket: TicketListItemModel;
}

export const CreatedAtCellContent: FC<CreatedAtCellContentProps> = ({
  ticket,
}) => {
  const { formatDateTimeLabel } = useFormattedDate();

  const createdAt = useMemo(
    () => new Date(ticket.inserted_at),
    [ticket.inserted_at]
  );

  return (
    <TableCell
      classNames={{ content: "flex items-center gap-2 overflow-hidden" }}
    >
      <span className="truncate text-[13px] leading-[140%] font-normal text-dark">
        {formatDateTimeLabel(createdAt, "concise")}
      </span>
    </TableCell>
  );
};
